export const UserRoles = {
    'SuperAdmin': 'Super Admin',
    'Admin':'Admin',
    'CompetencyLeader' : 'CompetencyLeader',
    'SubCompetencyLeader': 'SubCompetencyLeader',
    'Skill.User': 'Skill User',
    'Leadership': 'Leadership',
}